import { useSession } from '@/shared/hooks/useSession'
import { useLocation, useParams } from 'react-router-dom'
import { FinalizedReportStatus, useGetFinalizedReportPreview } from '@/shared/hooks/api/finalizedReports'
import { useEffect } from 'react'
import FinalizedReportPreviewEmbedded from '@/features/dashboard/pages/finalized-reports/finalized-report-page/components/FinalizedReportPreviewEmbedded'

export default function FinalizedReportPdf() {
  const { session } = useSession()
  const params = useParams<{ id: string }>()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const installationId = searchParams.get('installationId')
  const lang = searchParams.get('lang') || undefined
  if (!installationId || !params.id) {
    return null
  }

  useEffect(() => {
    document.body.style.setProperty('background-color', 'white')
  }, [])

  const { data: finalizedReport, isPending } = useGetFinalizedReportPreview(
    session.organization.id,
    installationId,
    params.id!
  )

  if (isPending) {
    return null
  }

  const isPreview = finalizedReport?.status === FinalizedReportStatus.PENDING

  return (
    <FinalizedReportPreviewEmbedded
      data={finalizedReport!}
      organization={session.organization}
      isPreview={isPreview}
      selectedPdfLanguage={lang}
    />
  )
}
